import React from "react";
import { FormSectionElements, FormSections, FormSubSections, LOVValues } from "../../entities/formTemplateDataType";
import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";
import { Button } from "primereact/button";
import { ConfirmDialog } from "primereact/confirmdialog";
import { Editor } from "primereact/editor";
import { Dialog } from "primereact/dialog";
import { getRootComponent } from "../../utilities/ElementUtils";
import Utils from "../../utilities/Utils";
import { MultiSelect } from "primereact/multiselect";
import { Checkbox } from "primereact/checkbox";
import { Dropdown } from "primereact/dropdown";
import { getPagedSummaryListOptions } from "../helpers/SearchFilterDialogHelpers";

interface Props {
    formSection: FormSections;
    ele: FormSectionElements;
    isEng: boolean;
    callback;
}
interface State {
    confirmVisible: boolean;
    deleteIndex: number;
    dialogVisibleForRadioOptions: boolean[];
    enableSearch: boolean;
    searchOnly: boolean;
}

export class SearchAutocompleteDesignComponent extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);

        const eleAny = this.props.ele as any;

        this.state = {
            confirmVisible: false,
            deleteIndex: -1,
            dialogVisibleForRadioOptions: [],
            enableSearch: eleAny.enableSearch || false,
            searchOnly: eleAny.searchOnly || false,
        };
    }

    dropdownHtml = () => {
        let p = this.props.ele;        

        let htmlString = [];

        if (p.ListOfLOVValues == null) {
            p.ListOfLOVValues = [];
        }

        if (p.ListOfLOVValues.length === 0) {
            let lov = new LOVValues();
            lov.parent=p;
            p.ListOfLOVValues.push(lov);
            console.log(lov);
        }

        htmlString.push(
            <button onClick={() => {
                p.displayInEditor = !p.displayInEditor;
                this.props.callback();
            }} >{p.displayInEditor==true ? "HTML":"Raw"}</button>)

        const summaryFilterLabel = this.getSelectedSummaryListFilterLabel();
        if (summaryFilterLabel) {
            htmlString.push(
                <div
                    key={`summary_filter_${p.Id}`}
                    style={{
                        width: "100%",
                        margin: "10px 0",
                        color: "#475569"
                    }}
                >
                    <strong>Summary list filter:</strong> {summaryFilterLabel}
                </div>
            );
        }

        p.ListOfLOVValues.forEach((lov: LOVValues, index) => {
            htmlString.push(
                <div
                    style={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "flex-start",
                        paddingTop: "5px",
                        alignItems: "center"
                    }}
                    key={"option_" + index}>
                    <div style={{ marginRight: "5px" }}>{index + 1}</div>
                    <div>
                        <i className="fa fa-regular fa-circle-dot"></i>
                    </div>
                    <div style={{ width: "10%" }}>
                        <InputText
                            className="ontario-input"
                            placeholder={"Code " + (index + 1).toString()}
                            value={lov.code}
                            onChange={(e) => {
                                lov.code = e.target.value;
                                this.props.callback();
                            }}
                        ></InputText>
                    </div>

                    <div style={{ width: "25%", marginLeft: "10px" }}>
                        <InputText
                            className="ontario-input"
                            placeholder={"Description " + (index + 1).toString()}
                            value={this.props.isEng?lov.description:lov.FRADescription}
                            onChange={(e) => {
                                if (this.props.isEng) { 
                                    lov.description = e.target.value
                                } else {
                                    lov.FRADescription = e.target.value
                                }
                                this.props.callback();
                            }}
                        ></InputText>
                    </div>

                    {p.displayInEditor && <div style={{ width: "50%", marginLeft: "10px" }}>
                        {/* @ts-ignore */}
                        <Editor style={{ height: 'auto' }}
                            placeholder="Rich text"
                            value={this.props.isEng ? lov.richText : lov.richTextFRA}
                            onTextChange={(e) => {
                                this.props.isEng
                                    ? (lov.richText = e.htmlValue)
                                    : (lov.richTextFRA = e.htmlValue);
                                this.props.callback();
                            }}></Editor>
                    </div>}
                    {p.displayInEditor || <div style={{ width: "60%", marginLeft: "10px" }}>
                        {/* @ts-ignore */}
                        <InputTextarea style={{ height: 'auto' }}
                            placeholder="Rich text"
                            value={this.props.isEng ? lov.richText : lov.richTextFRA}
                            onChange={(e) => {
                                this.props.isEng
                                    ? (lov.richText = e.target.value)
                                    : (lov.richTextFRA = e.target.value);
                                this.props.callback();
                            }}></InputTextarea>
                    </div>}

                    <div style={{ marginLeft: "20px", marginTop: "10px", width: "10%" }} key={`moreOptions_${lov.code}`}>
                        <i
                            title="More Options"
                            className="pi pi-ellipsis-v"
                            style={{ fontSize: "1rem", cursor: "pointer" }}
                            onClick={(e) => {
                                this.state.dialogVisibleForRadioOptions[index] = true;
                                
                                this.setState({ dialogVisibleForRadioOptions: this.state.dialogVisibleForRadioOptions });
                            }}
                        />
                    </div>

                    <div style={{ marginLeft: "10px" }}>
                        <i
                            title="Remove me"
                            className="pi pi-trash"
                            style={{ fontSize: "1rem", cursor: "pointer" }}
                            onClick={() => {
                                this.setState({ confirmVisible: true, deleteIndex: index });
                            }}
                        ></i>
                    </div>
                </div>
            );
            if (this.state.dialogVisibleForRadioOptions[index]) {
                htmlString.push(
                    <div>
                        {/* @ts-ignore */}
                        <Dialog
                            header={'Radio Button Options'}
                            visible={this.state.dialogVisibleForRadioOptions[index]}
                            footer={this.renderDialogFooter(index)}
                            style={{ width: '50vw' }}
                            onHide={() => {
                                this.state.dialogVisibleForRadioOptions[index] = false;
                                this.setState({ dialogVisibleForRadioOptions: this.state.dialogVisibleForRadioOptions });
                            }}
                        >
                            {this.generateFilterForLOVValue(lov)}
                        </Dialog>
                    </div>
                );
            }

        });

        htmlString.push(
            <div key={"addoption_" + p.Id}>
                {/* @ts-ignore */}
                <Button
                    className="p-button-rounded p-button-secondary"
                    style={{
                        cursor: "pointer",
                        margin: "5px",
                        fontSize: "90%",
                        border: "1px solid #64748B",
                        color: "#64748B",
                        background: "white"
                    }}
                    onClick={() => {
                        let newLov = new LOVValues();
                        newLov.Sequence = p.ListOfLOVValues.length;
                        newLov.parent=p;
                        p.ListOfLOVValues.push(newLov);
                        this.props.callback();
                    }}>
                    Add option
                </Button>
            </div>
        );

        const eleAny = p as any;
        htmlString.push(
            <div key={"searchconfig_" + p.Id} style={{ marginTop: '20px', paddingTop: '15px', borderTop: '1px solid #ddd' }}>
                <div style={{ width: '100%', display: "flex", alignItems: 'center', marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>
                        <label htmlFor={`enable_search_${p.Id}`}>
                            Enable Search Button:
                        </label>
                    </div>
                    <div style={{ width: '60%' }}>
                        <Checkbox
                            id={`enable_search_${p.Id}`}
                            checked={this.state.enableSearch}
                            onChange={(e) => {
                                eleAny.enableSearch = e.checked;
                                this.setState({ enableSearch: e.checked });
                                if (!e.checked) {
                                    eleAny.searchTargetSummaryListId = null;
                                }
                                this.props.callback();
                            }}
                        />
                    </div>
                </div>
                
                {this.state.enableSearch && (
                    <div style={{ display: "flex", marginTop: '10px' }}>
                        <div style={{ width: '25%' }}>
                            <label htmlFor={`search_target_${p.Id}`}>
                                Search Target (Paged Summary List):
                            </label>
                        </div>
                        <div style={{ width: '60%' }}>
                            <Dropdown
                                id={`search_target_${p.Id}`}
                                className="ontario-dropdown-small"
                                optionLabel="label"
                                optionValue="value"
                                options={getPagedSummaryListOptions(p, this.props.isEng)}
                                value={eleAny.searchTargetSummaryListId ?? null}
                                placeholder={this.props.isEng ? "Select paged summary list" : "Sélectionner la liste paginée"}
                                style={{ width: '100%' }}
                                onChange={(e) => {
                                    eleAny.searchTargetSummaryListId = e.value;
                                    this.props.callback();
                                }}
                            />
                        </div>
                    </div>
                )}

                <div style={{ width: '100%', display: "flex", alignItems: 'center', marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>
                        <label htmlFor={`search_only_${p.Id}`}>
                            Search Only:
                        </label>
                    </div>
                    <div style={{ width: '60%' }}>
                        <Checkbox
                            id={`search_only_${p.Id}`}
                            checked={this.state.searchOnly}
                            onChange={(e) => {
                                eleAny.searchOnly = e.checked;
                                this.setState({ searchOnly: e.checked });
                                this.props.callback();
                            }}
                        />
                    </div>
                </div>
            </div>
        );

        return htmlString;
    };

    getSummaryListColumnOptions = () => {
        const options: { value: string; label: string }[] = [];
        const root = getRootComponent(this.props.ele);
        const sections = root?.ListOfFormSections ?? [];

        sections.forEach((section: FormSections) => {
            section?.ListOfFormSubSections?.forEach((subSection: FormSubSections) => {
                subSection?.ListOfFormSectionElements?.forEach((element: FormSectionElements) => {
                    if (element?.Datatype === "SummaryList" && element.subSectionList?.length) {
                        const summaryTitle = this.props.isEng ? element.ENUTitle : element.FRATitle;
                        const summaryId = element.Id;
                        const columns = element.subSectionList[0]?.ListOfFormSectionElements ?? [];
                        columns.forEach((column: FormSectionElements) => {
                            const columnKey = column?.LoadBindName;
                            if (!columnKey) return;
                            const columnTitle = this.props.isEng ? column.ENUTitle : column.FRATitle;
                            options.push({
                                value: `${summaryId}|${columnKey}`,
                                label: `${summaryTitle || summaryId || "Summary List"} - ${columnTitle || columnKey}`
                            });
                        });
                    }
                });
            });
        });

        const unique = new Map<string, { value: string; label: string }>();
        options.forEach(option => {
            if (!unique.has(option.value)) {
                unique.set(option.value, option);
            }
        });

        return Array.from(unique.values());
    };

    getSelectedSummaryListFilterLabel = () => {
        const element: any = this.props.ele;
        if (!element?.filterSummaryListId) {
            return null;
        }
        const columns: string[] = Array.isArray(element.filterSummaryListColumns) && element.filterSummaryListColumns.length
            ? element.filterSummaryListColumns
            : (element.filterSummaryListColumn ? [element.filterSummaryListColumn] : []);
        if (!columns.length) return null;
        const options = this.getSummaryListColumnOptions();
        const labels = columns.map(col => {
            const composite = `${element.filterSummaryListId}|${col}`;
            return options.find(option => option.value === composite)?.label;
        }).filter(Boolean);
        if (!labels.length) return null;
        return labels.join(', ');
    };

    renderDialogFooter = (index: number) => {
        return (
            <div>
                {/* @ts-ignore */}
                <Button label="OK" icon="pi pi-check" onClick={() => {
                    this.state.dialogVisibleForRadioOptions[index] = false;
                    this.setState({ dialogVisibleForRadioOptions: this.state.dialogVisibleForRadioOptions });
                }} />
            </div>
        );
    }

    confirmRemove = () => {
        const { deleteIndex } = this.state;
        let p = this.props.ele;
        p.ListOfLOVValues.splice(deleteIndex, 1);
        this.props.callback();
        this.setState({ confirmVisible: false });
    };

     generateFilterForLOVValue = (lov: LOVValues) => {
        let html = [];
        let allElements = [];
        let elementListWithOptions = [];
        let container = getRootComponent(this.props.ele);

        let subsection = this.props.ele.parent as FormSubSections;
        //get elements to this element in the same subsection only
        let elementList = subsection.ListOfFormSectionElements.filter(p => p.Sequence < this.props.ele.Sequence);
        allElements.push(...elementList);

        let list = allElements.filter(
            (q) =>
                (q.Datatype === "RadioButton" ||
                q.Datatype === "CheckGroup" ||
                q.Datatype === "Dropdown" ||
                q.Datatype === "RadioButtonWithRichText")
        ).map((q) => {
            return {
                code: q.LoadBindName,
                description: this.props.isEng ? q.ENUTitle : q.FRATitle
            };
        });

        elementListWithOptions.push(...list);
    
        if (lov.FilterField == null || lov.FilterField == undefined || !Array.isArray(lov.FilterField)) {
            lov.FilterField = [];
        }
        // remove filter fields if no field exists with the same LoadBindName
        for (let i = lov.FilterField.length - 1; i >= 0; i--) {
            if (!elementListWithOptions.find(ele => ele.code == lov.FilterField[i])) {
                lov.FilterField.splice(i, 1);
            }
        }
        // lov.FilterField = lov.FilterField.filter(f => !elementListWithOptions.find(ele => ele.code == f));

        for (let option of elementListWithOptions) {
        
            let optionList = allElements.filter(p => p.LoadBindName == option["code"])[0].ListOfLOVValues;
            if (lov.FilterField.indexOf(option["code"]) == -1) {
                lov.FilterField.push(option["code"])
            }
            html.push(
                <>
                    <div style={{ display: "flex", marginTop: '10px' }}>
                        <div style={{ width: '25%' }}>Filtering Field</div>
                        <div style={{ width: '60%' }}>{this.props.isEng ? option["description"] : option["FRADescription"]}</div>
                    </div>
                    <div style={{ display: "flex", marginTop: '10px' }}>
                        <div style={{ width: '25%' }}>Filtering Value</div>
                        <div style={{ width: '60%', }}>
                            <div>
                                {/* @ts-ignore */}
                                <MultiSelect style={{ width: '100%' }}
                                    className="ontario-dropdown-small"
                                    options={optionList}
                                    value={lov.FilterValue ? lov.FilterValue[option.code] : null}
                                    optionLabel={this.props.isEng ? "description" : "FRADescription"}
                                    optionValue="code"
                                    placeholder="Filtering value"
                                    onChange={(e) => {
                                        if (Utils.isNullOrEmpty(lov.FilterValue) || typeof lov.FilterValue == "string")
                                            lov.FilterValue = {};
                                        lov.FilterValue[option.code] = e.value;
                                        this.props.callback(container);
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </>
            )


        }
        return html;
    }


    render() {
        return (
            <div>
                {this.dropdownHtml()}
                {/* @ts-ignore */}
                <ConfirmDialog
                    visible={this.state.confirmVisible}
                    onHide={() => this.setState({ confirmVisible: false })}
                    message="Are you sure you want to remove this?"
                    header="Confirmation"
                    icon="pi pi-exclamation-triangle"
                    accept={this.confirmRemove}
                    reject={() => this.setState({ confirmVisible: false })}
                    closable={false}
                />
            </div>
        );
    }
}
